module.exports = {
    addMember: {
        url: '/user/member/insert',
        method: 'post'
    },
    updateMember: {
        url: '/user/member/update',
        method: 'put'
    },
    getMembers: {
        url: '/user/member/list'
    },
    delMember: {
        url: '/user/member/:id',
        method: 'delete'
    },
    setDefaultMember: {
        url: '/user/member/default',
        method: 'put',
        dataType: 'form'
    }
};